<mat-form-field goSelect>
  <mat-select
    [hidden]="rubrics.length <= 1"
    [(ngModel)]="selected"
    [compareWith]="compareOptions"
    (selectionChange)="updated($event.value)"
    disableOptionCentering
    [disabled]="rubrics.length <= 1"
    panelClass="offsetPanel">
    <mat-select-trigger>
      <span>{{selected.user.last_name}}, {{selected.user.first_name}}</span>
    </mat-select-trigger>
    @for (rubric of rubrics; track rubric.id) {
      <mat-option [value]="rubric">
        <div class="rubric-filter-dropdown-option-template">
          <span>{{rubric.user.last_name}}, {{rubric.user.first_name}}</span>
          @if (isUnposted(rubric)) {
            <span translate="rubric-feedback-viewer_unposted-badge" class="rubric-feedback-viewer__dropdown-template--published goreact-badge"></span>
          }
          @if (shouldShowScore(rubric)) {
            <span>{{scoreText(rubric)}}</span>
          }
        </div>
      </mat-option>
    }
  </mat-select>
  <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
  <div [hidden]="rubrics.length > 1">{{rubrics[0].user.last_name}}, {{rubrics[0].user.first_name}}</div>
</mat-form-field>
